import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import OwnersGiftApply from "./pages/OwnersGiftApply";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/owners-gift" element={<OwnersGiftApply />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
